import { Link } from 'react-router-dom'
import classes from './logo.module.css'

export interface LogoProps {
  logoComponent: React.ReactNode
  closeMobileMenu?: VoidFunction
}

export const Logo = ({ logoComponent, closeMobileMenu }: LogoProps) => (
  <Link className={classes.logo} to='/' onClick={closeMobileMenu}>
    {logoComponent}
  </Link>
)
